import {
  login,
  authInfo
} from '@/serve/auth'
import {
  regions
} from '@/serve/regions'
import {
  setToken,
  removeToken
} from '@/utils/cookie'

const user = {
  state: {
    token: sessionStorage.getItem('token') || '',
    name: '',
    info: {}, // 用户信息
    keyWord: '', // 关键字
    loginType: sessionStorage.getItem('loginType') || 'STUDENT',
    ageStage: sessionStorage.getItem('ageStage') || '',
    blocTagBlocId: sessionStorage.getItem('blocTagBlocId') || ''
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    REMOVE_TOKEN: (state) => {
      state.token = null
      state.loginType = 'STUDENT'
      removeToken()
    },
    SET_NAME: (state, {
      name,
      welcome
    }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_INFO: (state, info) => {
      state.info = info
      if (info.admin === 100) {
        info.ageStage = ''
        info.blocTagBlocId = ''
      }
      state.loginType = info.schoolType
      state.ageStage = info.ageStage
      state.blocTagBlocId = info.blocTagBlocId
      sessionStorage.setItem('loginType', info.schoolType)
      if (!info.ageStage) {
        sessionStorage.setItem('ageStage', '')
      } else {
        sessionStorage.setItem('ageStage', info.ageStage)
      }
      if (!info.blocTagBlocId) {
        sessionStorage.setItem('blocTagBlocId', '')
      } else {
        sessionStorage.setItem('blocTagBlocId', info.blocTagBlocId)
      }
      sessionStorage.setItem('info', JSON.stringify(info))
    },
    SET_KEYWORD: (state, keyWord) => {
      state.keyWord = keyWord
    }
  },
  actions: {
    Login({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (typeof response.token === 'string') {
            commit('SET_TOKEN', response.token)
            authInfo().then(res => {
              commit('SET_INFO', res)
              if (res.state === 'NORMAL') {
                setToken(response.token)
              }
              resolve()
            })
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetInfo({
      commit
    }, token) {
      commit('SET_TOKEN', token)
      return new Promise((resolve, reject) => {
        authInfo().then(response => {
          if (response) {
            commit('SET_INFO', response)
            if (response.state === 'NORMAL') {
              setToken(token)
            }
            resolve(response)
          } else {
            commit('SET_INFO', {})
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取地区信息
    getRegionList({
      commit
    }) {
      return new Promise((resolve, reject) => {
        regions(0).then(res => {
          console.log(res)
        })
      })
    },
    // 登出
    Logout({
      commit,
      state
    }) {
      return new Promise((resolve) => {
        commit('REMOVE_TOKEN')
        resolve()
      })
    }
  }
}

export default user
